import React, { useMemo } from 'react';
import { View, ActivityIndicator, Text, StyleSheet } from 'react-native';
import { Colors, Typography, Spacing } from '../theme';
import { useTheme } from '../theme/useTheme';
import { daylightStyle } from '../theme/daylightStyle';

interface Props {
  label?: string;
  size?: 'small' | 'large';
  color?: string;
  appearanceAware?: boolean;
}

const LoadingSpinner: React.FC<Props> = ({
  label,
  size = 'large',
  color = Colors.sunset,
  appearanceAware = true,
}) => {
  const { theme } = useTheme();
  const appearanceStyles = useMemo(() => StyleSheet.create({
    container: appearanceAware
      ? daylightStyle(theme, { backgroundColor: theme.colors.background })
      : {},
    label: appearanceAware
      ? daylightStyle(theme, { color: theme.colors.textSecondary })
      : {},
  }), [appearanceAware, theme]);
  return (
    <View style={[styles.container, appearanceStyles.container]}>
      <ActivityIndicator size={size} color={color} />
      {label ? <Text style={[styles.label, appearanceStyles.label]}>{label}</Text> : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Colors.bg,
    gap: Spacing.md,
  },
  label: {
    color: Colors.textSecondary,
    fontSize: Typography.sm,
  },
});

export default LoadingSpinner;
